import { SvgIcon, SvgIconProps } from "@mui/material";

export default function EditIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 26">
      <defs>
        <path id="a" d="M0 0h8.293v8.287H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#62C3EE"
          d="M22.074 10.005c-.067.041-.161.077-.226.142-4.658 4.657-9.313 9.318-13.976 13.971a1.32 1.32 0 0 1-.578.328c-2.03.519-4.064 1.022-6.098 1.526-.528.13-.87-.21-.738-.739.511-2.068 1.023-4.137 1.545-6.203a.93.93 0 0 1 .234-.408c4.693-4.707 9.39-9.409 14.088-14.11.047-.048.1-.09.138-.124l5.611 5.617"
        />
        <g transform="translate(18.136)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#62C3EE"
            d="M5.502 8.287L0 2.779C.689 2.07 1.349 1.302 2.101.64 3.1-.244 4.731-.2 5.72.693c.659.595 1.29 1.226 1.883 1.886.922 1.025.923 2.64-.007 3.647-.664.72-1.396 1.379-2.093 2.06"
            mask="url(#b)"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
